module.exports = __webpack_public_path__ + "img/bank-gnb.498d28d8.png";